<template>
  <exclusive-service-dialog :visible.sync="visible"></exclusive-service-dialog>
</template>

<script>
import { mapState } from 'vuex';
import User from '@/libs/user';
import _ from 'lodash';
import ExclusiveServiceDialog from '@/components/fixed-right-service/components/dialog/exclusive-service-dialog/exclusive-service-dialog.vue';


const STORE_KEY = 'product_exclusive_dialog';

export default {
  props: {},
  components: {
    ExclusiveServiceDialog,
  },
  data() {
    return {
      visible: false,
      timer: null,
    };
  },
  computed: {
    ...mapState('user', ['peerCSData']),
    // 是否符合弹窗资格---登录+今天没有弹窗显示+非好友
    canDialog() {
      return User.isLogin() && !this.isShowExclusiveDialogInToday() && this.peerCSData && !this.peerCSData.is_friend;
    },
  },
  mounted() {
    if (this.canDialog) {
      // 监听鼠标移动、键盘敲击和滚动事件
      window.addEventListener('mousemove', this.resetTimer);
      window.addEventListener('keydown', this.resetTimer);
      window.addEventListener('scroll', this.resetTimer);
      // this.initEvent(); // 因为有些弹窗需要productInfo返回才会进行渲染，因此在请求中进行
    }
  },
  beforeDestroy() {
    // 移除事件监听器
    this.unBindEvent();
  },
  methods: {
    init() {
      if (this.canDialog) {
        this.$nextTick(() => {
          this.resetTimer();
        });
      }
    },
    // get/set 存储
    getOrSetStore(setVal) {
      const productExclusiveDialogStr = localStorage.getItem(STORE_KEY);
      let productExclusiveDialogMap = productExclusiveDialogStr ? JSON.parse(productExclusiveDialogStr) : {};
      if (setVal) {
        productExclusiveDialogMap = Object.assign(productExclusiveDialogMap, setVal);
        productExclusiveDialogMap[User.peer_account_id] = new Date().format('yyyy-MM-dd');
        localStorage.setItem(STORE_KEY, JSON.stringify(productExclusiveDialogMap));
        return;
      }
      return productExclusiveDialogMap[User.peer_account_id];
    },


    // 查看今天是否显示过弹窗
    isShowExclusiveDialogInToday() {
      // 获取该用户是否显示过
      const isToday = new Date().format('yyyy-MM-dd') === this.getOrSetStore();
      if (isToday) {
        return true;
      }
      return false;
    },

    // 重置
    resetTimer() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        if (!this.isShowDialog()) {
          this.getOrSetStore({
            [User.peer_account_id]: new Date().format('yyyy-MM-dd'),
          });
          this.visible = true;
          // 手动解绑事件
          this.unBindEvent();
        }
      }, 5000);
    },

    // 弹窗
    isShowDialog() {
      // 自动弹窗列表
      // const appIdList = ['follow-official-accounts-modal'];
      // const productIdList = [
      //   'visa-info-print',
      //   'share-with-friends',
      //   'send-material-by-email',
      //   'product-coupon',
      //   'coupon-explain',
      //   'coupon-usage',
      //   'ask-question',
      //   'notice-modal',
      //   'product-popup-dialog',
      //   'supplier-express-address-change',
      // ];

      // 全局获取el-dialog是否显示，如果显示则隐藏
      const allDialog = document.querySelectorAll('.el-dialog__wrapper');
      let showDialog = false;
      allDialog.forEach((dialog) => {
        if (dialog && dialog.style.display !== 'none') {
          showDialog = true;
        }
      });

      return showDialog;
    },

    unBindEvent() {
      window.removeEventListener('mousemove', this.resetTimer);
      window.removeEventListener('keydown', this.resetTimer);
      window.removeEventListener('scroll', this.resetTimer);
      this.timer && clearTimeout(this.timer);
    },

  },
};
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/product/components/product-exclusive-service-dialog.vue